export default __webpack_public_path__ + "static/sprite-ca3e45743d0d60776927cb717918b127.svg";